import { RefData } from '../../types';
import { secureRefSplitApi } from './ref-api';

const agentTypesApi = secureRefSplitApi.injectEndpoints({
  endpoints: (build) => ({
    fetchAgentTypes: build.query<RefData[], void>({
      query: () => ({
        url: '/agent-types',
        method: 'GET'
      })
    })
  }),
  overrideExisting: false
});

export const { useFetchAgentTypesQuery } = agentTypesApi;
